import { useRouter } from 'next/router'
import { SelectV2 as Select } from '@ticketswap/solar'
import useLanguage from '~/hooks/useLanguage'

const NativeMenuDropdown = ({ t, items }) => {
  const { push, pathname } = useRouter()
  const language = useLanguage()

  const displayedItems = [...items.primary, ...items.legal].filter(
    item => !item.languages || item.languages.includes(language)
  )

  const options = displayedItems.map(item => ({
    value: item.title,
    label: t(item.title),
  }))

  return (
    <Select
      onChange={event => {
        const { value } = event.target

        const currentItem = displayedItems.find(item => item.title === value)

        if (currentItem.url) {
          return (window.location = currentItem.url)
        }

        return push(currentItem.href)
      }}
      id="menu-dropdown"
      aria-label={t('common:footer.primary.title')}
      options={options}
      defaultValue={
        displayedItems.find(({ href = '/' }) => {
          if (typeof href === 'string') {
            return href === pathname
          }

          return href.pathname === pathname
        })?.title || ''
      }
    />
  )
}

export default NativeMenuDropdown
